import { ApiUtil as api } from "@/utils/api.util.js";

export class TemplateService {

  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = 'templates'

  static all(params = {}) {
    return api.get(`${this.URL}/${this.RESOURCE}`, params);
  }

  static show(id, params = {}) {
    return api.get(`${this.URL}/${this.RESOURCE}/${id}`, params);
  }

  static create(params = {}) {
    return api.post(`${this.URL}/${this.RESOURCE}`, params);
  }

  static update(id, params = {}) {
    return api.put(`${this.URL}/${this.RESOURCE}/${id}`, params);
  }
}



// WEBPACK FOOTER //
// ./src/services/template.service.js